import { api } from "../..";

const ApproversDashboardService = async (startDate?: string, endDate?: string) => {
    const response = await api.get('approvers/dashboard', {
        params: { startDate, endDate }
    });
    return response;
};

export { ApproversDashboardService };
